import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable, of, throwError } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthService, AuthType } from "../shared/services/auth.service";
import { EngagementEnum } from "./localstorage";


@Injectable({
  providedIn: "root",
})
export class EngagementProTokenResolverService  {
  constructor(
    private _authService: AuthService,
    private http: HttpClient,
  ) {
  }

  resolve() {
    const options = {
      headers: this._authService.buildAuthHeader(AuthType.Idenedi),
    };
    let url = `${environment.idenediProviderUrl}/api/oauth/AuthorizationCode?client_id=` + environment.engagementPro.clientId;

    if (this._authService.idenediGroupId) {
      url = `${environment.idenediProviderUrl}/api/oauth/AuthorizationCode?client_id=${environment.engagementPro.clientId}&gIdenedi=${this._authService.idenediGroupId}`;
    }


    return this.http.get<any>(url, options).pipe(
      catchError((errorResp) => {
        return throwError(errorResp);
      }),
      switchMap((code) => {
        const url = `${environment.engagementPro.baseURL}/api/Idenedi/Authenticate`;
        const data = {
          code,
          redirectUri: 'https://engpro-dev.azurewebsites.net/blank.html',
          deviceRegisterId: "",
          deviceTypeId: ""
        };
        return this.http.post<any>(url, data).pipe(
          catchError((errorResp) => {
            return throwError(errorResp);
          }),
          switchMap((user: any) => {
            localStorage.setItem(EngagementEnum.token, user.access_token);
            localStorage.setItem(EngagementEnum.user, JSON.stringify({
              organizationId: user.organizationId,
              userId: user.userId,
              userRole: user.userRole
            }));
            return of([]);
          })
        );
      })
    );
  }
}
